<template>
	<div class="home">
		<div class = "admin-link badge badge-danger" v-if="user.user_id"><router-link to="/admin">ADMIN</router-link></div>
		<div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
			<h1 class="display-4">Commande en ligne</h1>
			<p class = "lead">Nous ne pouvons pas effectuer de livraison.</p>
			<div class="container card">
				<div class = 'card-body'>
			<p>Ch&egrave;re cliente, cher client, </p>
			<p>Pour essayer de vous contenter au mieux, nous vous proposons des choix de &laquo; packs &raquo; &agrave; commander via cette page. Il s&rsquo;agit de packs avec des produits sp&eacute;cialement s&eacute;lectionn&eacute;s pour planter durant ce mois d&rsquo;avril (graines, l&eacute;gumes et plantes printani&egrave;res). </p>
			<p>Nous avons beaucoup de demandes pour des tomates, basilic, aneth, coriandre, verveine, c&ocirc;tes de bettes, piments, poivrons, aubergines, cucurbitac&eacute;es, gazon, g&eacute;ranium et autres fleurs d&rsquo;&eacute;t&eacute;&hellip; Or, il est encore trop t&ocirc;t pour planter ces produits, il faut attendre au minimum le d&eacute;but du mois de mai (min. 10&deg; la nuit) et nous aurons du stock jusqu&rsquo;au d&eacute;but de l&rsquo;&eacute;t&eacute;. Donc, n&rsquo;ayez crainte, vous pourrez les obtenir &agrave; notre r&eacute;ouverture.</p>
			<p>Nous sommes bien conscients que nos propositions ne vont pas satisfaire tout le monde, mais, vu la situation, notre effectif est plus que limit&eacute; et la gestion de commandes n&eacute;cessite une &eacute;norme organisation, du r&eacute;approvisionnement, des frais, des infrastructures et des comp&eacute;tences que nous n&rsquo;avons malheureusement pas forc&eacute;ment. On ne s&rsquo;improvise pas professionnels de la vente en ligne aussi rapidement.</p>
			<p>Nos vraies comp&eacute;tences sont de vous accueillir et de vous servir au mieux dans notre Garden Centre et nous esp&eacute;rons pouvoir le faire au plus vite.</p>
			<p>Nous esp&eacute;rons que vous trouverez votre bonheur dans nos propositions.</p>
			<p>Nous sommes impatients de pouvoir &agrave; nouveau vous accueillir dans notre Garden Centre.</p>
			<p>En attendant, prenez bien soin de vous et &agrave; tr&egrave;s bient&ocirc;t.</p>
			<p>Merci</p>
			<p><b>L’équipe du Garden Centre de Lavaux</b></p>
				
				</div>
			</div>
		</div>

		<div class="container">
			<h3 class = 'py-2'>Nos packs</h3>
			<p>Voici nos différentes propositions de « pack », vous trouverez le descriptif de chaque contenu (<b>non modifiable</b>) en cliquant sur le bouton « Détails ». Sélectionnez votre (ou vos) pack, et ajustez les quantités souhaitées dans le formulaire de commande.</p>
			
			<div class="row row-cols-1 row-cols-md-3">
				<div class="col mb-4" v-for="sel in selPacks" :key='sel.pack_id'>
					<div class="card h-100  shadow-sm text-center">
						<div class="card-header">
							<h4 class="my-0 font-weight-normal">{{sel.name}} </h4>
						</div>
						<div class="card-body">
							<!-- <img src="../assets/pack4/main.jpg" class="card-img-top" alt="Main"> -->
							<img :src="require(`../assets/pack${sel.pack_id}/main_sm.jpg`)" class="card-img-top" :alt="sel.name">
							<h5 class="card-title pricing-card-title my-3">{{`${formatPrice(sel.price)}`}}</h5>
							<p class="card-title my-3" v-html="sel.description.replace('\n','<br>')"></p>
						</div>
						<div class = 'card-footer'>
							<p>

								<button type="button" class="btn btn-sm  btn-outline-primary" @click='details(sel.pack_id)'>Détails</button>
								<button type = 'button' class = 'ml-2 btn btn-sm btn-success' @click="addPackToChart(sel.pack_id)" v-if="+sel.nb < +sel.stock">Commander</button>
								<span class = 'text-muted px-3' v-if="+sel.nb >= +sel.stock">épuisé temporairement</span>
							</p>
						</div>
					</div>
				</div>
			</div>

			<h3 class = 'py-2'>Nos articles individuels (uniquement terreaux et jardinières)</h3>


			<div class="row row-cols-1 row-cols-md-4">
				<div class="col mb-4" v-for="sel in articlePacks" :key='sel.pack_id'>
					<div class="card h-100  shadow-sm text-center">
						<div class="card-header">
							<h5 class="my-0 font-weight-normal">{{sel.name}} </h5>
						</div>
						<div class="card-body">
							<!-- <img src="../assets/pack4/main.jpg" class="card-img-top" alt="Main"> -->
							<img :src="require(`../assets/pack${sel.pack_id}/main_sm.jpg`)" class="card-img-top" :alt="sel.name">
							<h5 class="card-title pricing-card-title my-3">{{`${formatPrice(sel.price)}`}}</h5>
							<p class="card-title my-3" v-html="sel.description.replace('\n','<br>')"></p>
						</div>
						<div class = 'card-footer'>
							<p>
								<button type = 'button' class = 'ml-2 btn btn-sm btn-success' @click="addPackToChart(sel.pack_id)" v-if="+sel.nb < +sel.stock">Commander</button>
								<span class = 'text-muted' v-if="+sel.nb >= +sel.stock">épuisé temporairement</span>
							</p>
						</div>
					</div>
				</div>
			</div>

		</div>
		
		<hr />
		
		<commande></commande>
		
		<b-modal id="detailModal" size="lg">
			<template v-slot:modal-title>
				<h5 class="card-title pricing-card-title">Pack {{currentPack.name}} <span class = 'ml-3 text-muted'>{{`${formatPrice(currentPack.price)}`}}</span></h5>
			</template>
			
			<b-carousel :id="`carousel-${currentPack.name}`" v-model="slide" :interval="2000" controls indicators	background="#ababab" style="text-shadow: 1px 1px 2px #333;">
			<!-- Text slides with image -->
				<b-carousel-slide v-for="img in currentPack.images" :key="img" :img-src="require(`../assets/pack${currentPack.pack_id}/${img}`)">
					<p><small>photo non contractuelle</small></p>
				</b-carousel-slide>
			</b-carousel>
			<div class = 'container'>
				<p class="card-title my-3 lead" v-html="currentPack.description.replace('\n','<br>')"></p>
				<b-table small :items="currentPack.articles" :fields="fields" sort-by="name" foot-clone>
					<template v-slot:cell(prix)="data">{{`${formatPrice(data.value)}`}}</template>
					<template v-slot:cell(total)="row">{{`${formatPrice(+row.item.prix*row.item.quantite)}`}}</template>
					<template v-slot:foot(quantite)=""><span class="d-none d-sm-block">Total</span></template>
					<template v-slot:foot(total)="">{{`${formatPrice(computeTotal(currentPack.pack_id))}`}}</template>
					<template v-slot:foot()="data">{{data.value}}</template>
				</b-table>
				<p class = 'text-muted'><i>sous réserve de modification en fonction des stocks disponibles </i></p>
				
			</div>
			<template v-slot:modal-footer>
			<!-- Emulate built in modal footer ok and cancel button actions -->
				<b-button size="sm" variant="success" @click="addPackToChart(currentPack.pack_id)" v-if="+currentPack.nb < +currentPack.stock">
					Ajouter à la commande
				</b-button>
				<span class = 'text-muted' v-if="+currentPack.nb >= +currentPack.stock">épuisé temporairement</span>
				<b-button size="sm" variant="" @click="$bvModal.hide('detailModal')">Fermer</b-button>
			</template>
		</b-modal>
		<b-toast id="toast" title="Succès" variant="success">
			Le produit a été ajouté à la commande
		</b-toast>
		<b-toast id="toastStock" title="Stock épuisé" variant="warning">
			Désolé, le stock est temporairement épuisé
		</b-toast>
	</div>
</template>

<script>
// @ is an alias to /src
import Commande from '@/components/Commande.vue'
import { mapGetters } from 'vuex'
export default {
	name: 'Home',
	data () {
		return {
			view: '',
			slide: 0,
			fields: [
				{
					key: 'quantite',
					label: 'Qte'
				},
				{
					key: 'name',
					label: 'Nom'
				},
				{
					key: 'conditionnement',
					label: 'Conditionnement'
				},
				{
					key: 'prix',
					label: 'Prix unitaire'
				},
				{
					key: 'total',
					label: 'Prix total',
					class: 'd-none d-sm-block'
				}
			]
		}
	},
	components: {
		Commande
	},
	computed: {
		...mapGetters({
			packs: 'packs',
			user: 'user'
		}),
		currentPack () {
			if (this.view) {
				return _.filter(this.packs, i => i.pack_id === this.view)[0]
			}
			return {
				name: '',
				description: ''
			}
		},
		selPacks () {
			return _.filter(this.packs, p => p.articles.length > 1)
		},
		articlePacks () {
			return _.filter(this.packs, p => p.articles.length === 1)
		}
	},
	methods: {
		details (id) {
			this.view = id;
			this.$bvModal.show('detailModal')
		},
		addPackToChart (pack_id) {
			let packIdx = _.findIndex(this.packs, p => p.pack_id === pack_id)
			if (this.packs[packIdx].stock > this.packs[packIdx].nb) {
				this.$store.commit("ADD_TO_SELECTION",{pack_id: pack_id})				
				this.$bvToast.show('toast')
			}
			else {
				this.$bvToast.show('toastStock')
			}

			this.$bvModal.hide('detailModal')

		},
		formatPrice(price) {
			function formatMoney(number, decPlaces, decSep, thouSep) {
				decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
				decSep = typeof decSep === "undefined" ? "." : decSep;
				thouSep = typeof thouSep === "undefined" ? "," : thouSep;
				var sign = number < 0 ? "-" : "";
				var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
				var j = (j = i.length) > 3 ? j % 3 : 0;

				return sign +
				(j ? i.substr(0, j) + thouSep : "") +
				i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
				(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
			}
			return formatMoney(+price,2, ".", "'");
		},
		computeTotal (pack_id) {
			const idx = _.findIndex(this.packs, p => p.pack_id === pack_id)
			if (idx > -1) {
				let sum = 0;
				_.forEach(this.packs[idx].articles, a => {
					sum += +a.prix*+a.quantite
				})
				return sum
			}
			return ''
		}
	},
	beforeMount () {
		this.$store.dispatch('getPacks')
		this.$store.dispatch('getCredentials')
	}
}
</script>
<style>
div.card-header > h4 {
	text-align: left;
}
div.admin-link{
	position: absolute;
	right: 40px;
	top: 10px;
	font-size: 13px;
}
div.admin-link a {
	color: #FFF;
}
div.admin-link a:hover{
	text-decoration: none;
}
</style>